import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useAppSnackbarStore } from "@faire/retailer-visitor-shared/stores/ui/AppSnackbarStore";
import { getMetaDescription, getMetaTitle } from "@faire/retailer-visitor-shared/views/product/__internal__/SEOMetaText";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import React from "react";
export var SEOProductInfo = function(param) {
    var productName = param.productName, productDescription = param.productDescription, brandCompanyName = param.brandCompanyName;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useAppSnackbarStore = _sliced_to_array(useAppSnackbarStore([
        "productTitle"
    ]), 1), productTitle = _useAppSnackbarStore[0].productTitle;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var title = isLoggedInRetailer ? getMetaTitle({
        productName: productTitle,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    }, strictLocalize, false) : getMetaTitle({
        productName: productName,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    }, strictLocalize);
    var description = getMetaDescription({
        productName: productName,
        brandCompanyName: brandCompanyName,
        productDescription: productDescription,
        isFaireDirectActiveInLoggedOut: isFaireDirectActiveInLoggedOut
    }, strictLocalize);
    return /*#__PURE__*/ _jsx(FaireHelmet, {
        title: title,
        description: description
    });
};
SEOProductInfo.displayName = "SEOProductInfo";
